import { TOSPageLayout } from "../pagelayouts/tos";
import { useMarketingPagesTracking } from "../hooks/marketingPagesTracking";
import { GoogleTagManagerScript } from "../tracking/GoogleTagManager/GoogleTagManagerScript";

const TOS = () => {
    useMarketingPagesTracking();

    return (
        <>
            <GoogleTagManagerScript />
            <TOSPageLayout />
        </>
    );
}

export async function getStaticProps() {
    return {
        props: {}
    }
}

export default TOS